import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ValidationPinCode from "../../../components/ValidationPinCode";

import {
	emailConfirmationRequest,
	setEmailConfirmationError,
	validateInitialOnboardingEmail,
} from "../../../store/modules/register/actions";
import { hideCharactersEmail } from "../../../utils";

const ConfirmationCodeEmail = (props) => {
	const { creationType, creationData } = props;

	const dispatch = useDispatch();

	const { initialOnboardingResponseData, validateInitialOnboardingResponse, emailConfirmationError } =
		useSelector((state) => state.register);

	const [seconds, setSeconds] = useState(30);
	const [tokenRecaptcha, setTokenRecaptcha] = useState({});
	const [isResend, setIsResend] = useState(false);
	const [error, setError] = useState(false);
	const [messageError, setMessageError] = useState("");

	useEffect(() => {
		if (
			validateInitialOnboardingResponse &&
			Object.keys(validateInitialOnboardingResponse).length &&
			isResend
		) {
			setSeconds(validateInitialOnboardingResponse.seconds);
		}
	}, [validateInitialOnboardingResponse, isResend]);

	useEffect(() => {
		setError(Boolean(emailConfirmationError.length));
		setMessageError(emailConfirmationError);
	}, [emailConfirmationError]);

	useEffect(() => {
		if (isResend && Object.values(tokenRecaptcha).length) {
			dispatch(
				validateInitialOnboardingEmail(
					initialOnboardingResponseData.cd_access_token,
					null,
					null,
					tokenRecaptcha
				)
			);
			setIsResend(false);
		}
	}, [tokenRecaptcha, isResend]);

	const resendCode = useCallback(() => {
		setIsResend(true);
	}, []);

	const submitCode = (pin) => {
		dispatch(
			emailConfirmationRequest({
				cd_access_token: initialOnboardingResponseData.cd_access_token,
				email: creationData,
				verification: pin,
			})
		);
	};

	const onChange = () => {
		if (emailConfirmationError.length) {
			setMessageError("");
			setError(false);
			dispatch(setEmailConfirmationError(""));
		}
	};

	return (
		<ValidationPinCode
			title="Criar uma conta"
			subtitle={`Digite o código <span style='color: var(--brand-primary);'>enviado</span> para o ${creationType} ${hideCharactersEmail(creationData)} <br />Caso não tenha recebido, aguarde ou solicite para reenviarmos.`}
			resendType={creationType}
			seconds={seconds}
			onResendCode={resendCode}
			onSubmit={submitCode}
			setTokenRecaptcha={setTokenRecaptcha}
			error={error}
			messageError={messageError}
			onChange={onChange}
		/>
	);
};

export default ConfirmationCodeEmail;
